import {
  useMatrixDeliveryWindowContext,
  useMatrixDistributionContext,
  useMatrixPrepackContext,
  useMatrixSettingsContext,
  useMatrixVariantsContext,
} from '@app/components/products/ProductMatrix/context';
import { PrepackSwitch } from '@app/components/various/Matrix/MatrixContents/PrepackSwitch';
import { SizeDistribution } from '@app/components/various/Matrix/MatrixContents/SizeDistribution';
import { VerticalSeparator } from '@app/components/various/VerticalSeparator';
import { isDefined } from '@app/utils/is';
import React from 'react';

export const DistributionControls = React.forwardRef<HTMLDivElement>((_, ref) => {
  const { isDesktop } = useMatrixSettingsContext();
  const { deliveryWindowId } = useMatrixDeliveryWindowContext();
  const { variants } = useMatrixVariantsContext();
  const { shouldHidePrepackSwitch } = useMatrixPrepackContext();
  const { distributionsMap, shouldHideDistribution, variantsWithDisabledDistributions } = useMatrixDistributionContext();

  const [firstVariant] = variants;

  if (!isDefined(firstVariant)) {
    return null;
  }

  const isDistributionDisabled = variantsWithDisabledDistributions.includes(firstVariant.variant);
  const distributions = distributionsMap[firstVariant.variant];

  if (isDesktop || (shouldHideDistribution && shouldHidePrepackSwitch) || !isDefined(distributions)) {
    return null;
  }

  return (
    <>
      <div className="flex items-center gap-3" ref={ref}>
        {!shouldHidePrepackSwitch && <PrepackSwitch variantId={firstVariant.variant} showPrepackInLine />}
        {!shouldHidePrepackSwitch && !shouldHideDistribution && <VerticalSeparator />}
        {!shouldHideDistribution && (
          <SizeDistribution
            variant={firstVariant}
            deliveryWindowId={deliveryWindowId}
            disabled={isDistributionDisabled}
            distributions={distributions}
            shouldShowLabel
          />
        )}
      </div>
    </>
  );
});
